module.exports = __webpack_public_path__ + "img/media_1.22d2e3d3.jpg";